module.exports = __webpack_public_path__ + "img/machine-learning.27475a50.svg";